import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetManagementAssociationDetailAction} from '../action';

function* execute({payload: {userRoleId}}: GetManagementAssociationDetailAction): SagaIterator {
    const response = yield* call(Api.getUserProfileAssociationRoleBinding, {userRoleId});

    if (response.isSuccess) {
        const optData = opt(response.data);
        yield* put(adminAction.getManagementAssociationDetailSuccess(optData));
        yield* put(adminAction.setManagementAssociationsUsers(optData.prop('user').toArray()));
        yield* put(adminAction.setManagementAssociationsRoles(optData.prop('role').toArray()));
    } else {
        yield putAll(showBeError(response, t('admin')('loadDetail')));
    }
}
/** Runs the admin saga that loads the selected association-management detail. */
export function* getManagementAssociationDetailSaga(): SagaIterator {
    yield takeLatestF('admin/GET_MANAGEMENT_ASSOCIATION_DETAIL', execute);
}
